export const slugifyString = (s: string): string => {
    return s
        .toLowerCase()
        .trim()
        .normalize('NFD')
        .replace(/[^a-z0-9 -]^[\u4e00-\u9fa5]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace('-?', '')
        .replace('?', '');
};
